<div class="d-flex logo-margin">
  <img
    *ngIf="product.inpressLogo"
    src="/assets/logo.png"
    class="inpress-logo"
  />
  <img
    *ngIf="product.immoscoopLogo"
    src="/assets/immoscoop_banner.png"
    class="immoscoop-logo"
    [ngClass]="product.inpressLogo ? 'left-space' : ''"
  />
  <img
    *ngIf="product.spottoLogo"
    src="/assets/spotto_banner.png"
    class="spotto-logo"
    [ngClass]="product.spottoLogo ? 'left-space' : ''"
  />
</div>

<file-picker
  [title]="'Bestanden'"
  [inputProduct]="product"
  [formSection]="'sketchUp'"
></file-picker>

<board-loadlist
  *ngIf="product.type === productTypes.BOARD.value"
  [board]="product"
  (update)="update.emit()"
></board-loadlist>
